import { render, staticRenderFns } from "./quoteCartTable.vue?vue&type=template&id=20618d06&scoped=true&"
import script from "./quoteCartTable.vue?vue&type=script&lang=js&"
export * from "./quoteCartTable.vue?vue&type=script&lang=js&"
import style0 from "./quoteCartTable.vue?vue&type=style&index=0&id=20618d06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20618d06",
  null
  
)

export default component.exports